import type { Resource } from "@/content/resources";

export interface RouteMetadata {
    title: string;
    description: string;
    path: string;
    canonicalPath?: string;
    robots?: string;
}

export const routeMetadata = {
    home: {
        title: "Central Auckland Church of Christ",
        description: "Join Central Auckland Church of Christ for Sunday worship at 10:00 AM in Freemans Bay. Meet our community, explore ministries, and plan your first visit.",
        path: "/",
    },
    about: {
        title: "About Us",
        description: "Learn about the beliefs, mission, and church family at Central Auckland Church of Christ in Auckland, New Zealand.",
        path: "/about",
    },
    visit: {
        title: "Visit Us",
        description: "Plan your visit to Central Auckland Church of Christ, including service times, location details, and how to connect with a small group in Auckland.",
        path: "/visit",
    },
    giving: {
        title: "Giving",
        description: "Find giving details for Central Auckland Church of Christ, including regular contribution, benevolence, and missions support information.",
        path: "/giving",
    },
    contact: {
        title: "Contact Us",
        description: "Contact Central Auckland Church of Christ to plan a visit, request prayer, start a Bible study, or ask a general question.",
        path: "/contact",
    },
    events: {
        title: "Events",
        description: "See upcoming gatherings, worship events, and church activities at Central Auckland Church of Christ in Auckland.",
        path: "/events",
    },
    resources: {
        title: "Resources",
        description: "Browse Bible study and devotional PDF resources from Central Auckland Church of Christ to support spiritual growth and discipleship.",
        path: "/resources",
    },
    videos: {
        title: "Watch",
        description: "Watch the latest messages and videos from Central Auckland Church of Christ.",
        path: "/videos",
    },
    gallery: {
        title: "Photo Gallery",
        description: "Explore photos, gatherings, and community moments from Central Auckland Church of Christ and Instagram.",
        path: "/gallery",
    },
    privacy: {
        title: "Privacy Policy",
        description: "Read how Central Auckland Church of Christ handles contact form submissions, embedded services, and personal information shared through this website.",
        path: "/privacy-policy",
    },
    benevolence: {
        title: "Member Benevolence Portal",
        description: "Confidential benevolence request portal for Central Auckland Church of Christ members.",
        path: "/benevolence",
        robots: "noindex, nofollow, noarchive",
    },
} satisfies Record<string, RouteMetadata>;

export function getResourceDetailMetadata(resource?: Resource): RouteMetadata {
    if (!resource) {
        return {
            title: "Resource Not Found",
            description: "The requested resource could not be found. Browse the available study and devotional resources instead.",
            path: "/resources",
            canonicalPath: "/resources",
            robots: "noindex, follow",
        };
    }

    return {
        title: `${resource.title} Resource`,
        description: resource.description,
        path: `/resources/${resource.id}`,
        canonicalPath: "/resources",
        robots: "noindex, follow",
    };
}
